// removed by extract-text-webpack-plugin
module.exports = {"title":"_3nBTlK7Inp8Kh5CyHnfBYc","text":"_1njWXbUJIl_edI6CHddYEG"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Title.less
// module id = 1521
// module chunks = 0